var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _circle2, _circle3, _path10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgJoincompany(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 141,
    viewBox: "0 0 140 141",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 66.133,
    cy: 65.0165,
    r: 60.3205,
    fill: "#E9F0FE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.1848 123.177C94.3366 119.831 104.952 112.778 112.74 103.311V48.8133L82.1848 40.4394L82.1848 123.177ZM69.563 125.241C73.9091 124.997 78.1324 124.293 82.1848 123.177V24.4495L23.0117 36.358V107.197C33.2161 117.627 47.1741 124.37 62.7007 125.241H69.563Z",
    fill: "#256AF5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.3211 105.558H62.9988V125.241C55.5515 124.706 50.9862 123.813 44.3203 121.237L44.3211 105.558Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2344 50.803H48.1216M57.0767 50.803H71.9639",
    stroke: "white",
    strokeWidth: 4.5,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2344 65.3313H48.1216M57.0767 65.3313H71.9639",
    stroke: "white",
    strokeWidth: 4.5,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2344 79.8596H48.1216M57.0767 79.8596H71.9639",
    stroke: "white",
    strokeWidth: 4.5,
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2344 94.3879H48.1216M57.0767 94.3879H71.9639",
    stroke: "white",
    strokeWidth: 4.5,
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M88.0391 65.3313H100.605",
    stroke: "white",
    strokeWidth: 4.5,
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M88.0391 79.8596H100.605",
    stroke: "white",
    strokeWidth: 4.5,
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M88.0391 94.3879H100.605",
    stroke: "white",
    strokeWidth: 4.5,
    strokeLinejoin: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 105.373,
    cy: 107.089,
    r: 28.6191,
    fill: "#6CCC93"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 105.373,
    cy: 97.7621,
    r: 9.2203,
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M90.8594 113.958C90.8594 109.539 94.4411 105.958 98.8594 105.958H111.889C116.307 105.958 119.889 109.539 119.889 113.958V121.043H90.8594V113.958Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJoincompany);
export default __webpack_public_path__ + "static/media/joincompany.9db67b9f94c60807db1ef523cbf31093.svg";
export { ForwardRef as ReactComponent };